import Error404 from '@containers/Error404';
import Full from '@containers/Full';
import BrowseAssociations from '@views/Associations/Container';
import CreateBaseFertiliserDiary from '@views/BaseFertiliserDiary/Container';
import ViewBaseFertiliserDiary from '@views/BaseFertiliserDiary/View';
import BrowseBlocks from '@views/Blocks/Container';
import CreateBlock from '@views/Blocks/Create';
import UpdateBlock from '@views/Blocks/Update';
import BrowseChemicalActiveIngredients from '@views/ChemicalActiveIngredients/Container';
import BrowseChemicalClassifications from '@views/ChemicalClassifications/Container';
import BrowseChemicalCommercialVariants from '@views/ChemicalCommercialVariants/Container';
import BrowseChemicalTargets from '@views/ChemicalTargets/Container';
import BrowseCountries from '@views/Countries/Container';
import BrowseCropTypes from '@views/CropTypes/Container';
import Dashboard from '@views/Dashboard/Main';
import BrowseDistricts from '@views/Districts/Container';
import BrowseFertiliserAdditives from '@views/FertiliserAdditives/Container';
import BrowseFertilisers from '@views/Fertilisers/Container';
import BrowseFinalSprayBlocks from '@views/FinalSprayBlocks/Container';
import BrowseGrowerBlocks from '@views/GrowerBlocks/Container';
import BrowseGrowerChemicals from '@views/GrowerChemicals/Container';
import BrowseGrowerOrchardMaps from '@views/GrowerOrchardMaps/Container';
import BrowseGrowers from '@views/Growers/Container';
import Login from '@views/Login';
import BrowsePackages from '@views/Packages/Container';
import BrowseProcessors from '@views/Processors/Container';
import ViewSetup from '@views/Setup/View';
import BrowseRegions from '@views/Regions/Container';
import BrowseSprayDiary from '@views/SprayDiary/Browse';
import CreateSprayDiary from '@views/SprayDiary/Container';
import ViewSprayDiary from '@views/SprayDiary/View';
import ViewStockManager from '@views/StockManagement/View';
import BrowseUsers from '@views/Users/Container';
import BrowseVarieties from '@views/Varieties/Container';
import BrowseVarietyGroups from '@views/VarietyGroups/Container';
import BrowseWeedSprayDiary from '@views/WeedSprayDiary/Browse';
import CreateWeedSprayDiary from '@views/WeedSprayDiary/Container';
import BrowseWithholdingPeriods from '@views/WithholdingPeriods/Container';
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'home',
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          component: Dashboard,
        },
        {
          path: 'setup/:view?',
          name: 'setup',
          component: ViewSetup,
          props: true,
        },
        {
          path: 'stock-management/:view?/:id?',
          name: 'stock-management',
          component: ViewStockManager,
          props: true,
        },
        {
          path: 'users/:role?',
          name: 'users.browse',
          component: BrowseUsers,
          props: true,
        },
        {
          path: 'growers',
          name: 'growers.browse',
          component: BrowseGrowers,
        },
        {
          path: 'growers/blocks/:blockId',
          name: 'growers.blocks.view',
          component: BrowseBlocks,
          props: true,
        },
        {
          path: 'growers/:growerId/blocks',
          name: 'growers.blocks.browse',
          component: BrowseGrowerBlocks,
          props: true,
        },
        {
          path: 'growers/:growerId/diary/create',
          name: 'growers.diary.create',
          component: CreateSprayDiary,
          props: true,
        },
        {
          path: 'growers/:growerId/chemicals',
          name: 'growers.chemicals.browse',
          component: BrowseGrowerChemicals,
          props: true,
        },
        {
          path: 'growers/:growerId/orchard-maps',
          name: 'growers.orchard-maps.browse',
          component: BrowseGrowerOrchardMaps,
          props: true,
        },
        {
          path: 'blocks/final-spray',
          name: 'final-spray.blocks.browse',
          component: BrowseFinalSprayBlocks,
        },
        {
          path: 'blocks/final-spray/crop-type/:cropTypeId',
          name: 'final-spray.blocks.crop-type.browse',
          component: BrowseFinalSprayBlocks,
          props: true,
        },
        {
          path: 'associations',
          name: 'associations.browse',
          component: BrowseAssociations,
        },
        {
          path: 'processors',
          name: 'processors.browse',
          component: BrowseProcessors,
        },
        {
          path: 'chemical-targets',
          name: 'chemical-targets.browse',
          component: BrowseChemicalTargets,
        },
        {
          path: 'chemical-active-ingredients',
          name: 'chemical-active-ingredients.browse',
          component: BrowseChemicalActiveIngredients,
          props: true,
        },
        {
          path: 'chemical-classifications',
          name: 'chemical-classifications.browse',
          component: BrowseChemicalClassifications,
        },
        {
          path: 'chemical-commercial-variants',
          name: 'chemical-commercial-variants.browse',
          component: BrowseChemicalCommercialVariants,
        },
        {
          path: 'countries',
          name: 'countries.browse',
          component: BrowseCountries,
        },
        {
          path: 'packages',
          name: 'packages.browse',
          component: BrowsePackages,
        },
        {
          path: 'fertilisers',
          name: 'fertilisers.browse',
          component: BrowseFertilisers,
        },
        {
          path: 'fertilisers/additives',
          name: 'fertiliser-additives.browse',
          component: BrowseFertiliserAdditives,
        },
        {
          path: 'withholding-periods',
          name: 'withholding-periods.browse',
          component: BrowseWithholdingPeriods,
        },
        {
          path: 'regions/:countryId',
          name: 'regions.browse',
          component: BrowseRegions,
          props: true,
        },
        {
          path: 'districts/:regionId',
          name: 'districts.browse',
          component: BrowseDistricts,
          props: true,
        },
        {
          path: 'crop-types',
          name: 'crop-types.browse',
          component: BrowseCropTypes,
        },
        {
          path: 'variety-groups/:cropTypeId',
          name: 'variety-groups.browse',
          component: BrowseVarietyGroups,
          props: true,
        },
        {
          path: 'varieties/:varietyGroupId',
          name: 'varieties.browse',
          component: BrowseVarieties,
          props: true,
        },
        {
          path: 'diary/update/:logId',
          name: 'spray-diary.update',
          component: CreateSprayDiary,
          props: true,
        },
        {
          path: 'blocks',
          name: 'blocks.browse',
          component: BrowseBlocks,
        },
        {
          path: 'base-fertiliser/create',
          name: 'base-fertiliser.create',
          component: CreateBaseFertiliserDiary,
          props: true,
        },
        {
          path: 'base-fertiliser/update/:logId',
          name: 'base-fertiliser.update',
          component: CreateBaseFertiliserDiary,
          props: true,
        },
        {
          path: 'base-fertiliser/:blockId?',
          name: 'base-fertiliser.view',
          component: ViewBaseFertiliserDiary,
          props: true,
        },
        {
          path: 'blocks/crop-type/:cropTypeId/diary/create',
          name: 'blocks.crop-type.spray-diary.create',
          component: CreateSprayDiary,
          props: true,
        },
        {
          path: 'blocks/crop-type/:cropTypeId',
          name: 'blocks.crop-type.browse',
          component: BrowseBlocks,
          props: true,
        },
        {
          path: 'blocks/create/:cropTypeId',
          name: 'blocks.create',
          component: CreateBlock,
          props: true,
        },
        {
          path: 'diary/create',
          name: 'spray-diary.create-bulk',
          component: CreateSprayDiary,
          props: true,
        },
        {
          path: 'blocks/:blockId/diary/create',
          name: 'spray-diary.create',
          component: CreateSprayDiary,
          props: true,
        },
        {
          path: 'diary-by-date/:startRange',
          name: 'spray-diary.view-by-date',
          component: ViewSprayDiary,
          props: true,
        },
        {
          path: 'blocks/:blockId/diary',
          name: 'spray-diary.view',
          component: ViewSprayDiary,
          props: true,
        },
        {
          path: 'sprayDiary/browse/:startRange?',
          name: 'spray-diary.browse',
          component: BrowseSprayDiary,
          props: true,
        },

        //----------------------------
        // Weed Spray Log
        {
          path: 'weedSprayDiary/create',
          name: 'weed-spray-diary.create-bulk',
          component: CreateWeedSprayDiary,
          props: true,
        },
        {
          path: 'blocks/:blockId/weedSprayDiary/create',
          name: 'weed-spray-diary.create',
          component: CreateWeedSprayDiary,
          props: true,
        },
        {
          path: 'weedSprayDiary/browse',
          name: 'weed-spray-diary.browse',
          component: BrowseWeedSprayDiary,
        },

        {
          path: 'blocks/:blockId',
          name: 'blocks.update',
          component: UpdateBlock,
          props: true,
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: (to, from, next) => window.Application.authenticated ? next('/') : next(),
    },
    { path: '*', component: Error404 },
  ],
});

router.push = function (location) {
  window.location.href = router.resolve(location).href;
};

router.beforeEach((to, from, next) => {
  try {
    const component = to.matched[1].components.default.name;
    console.log(`%cMatched route '${to.name}' rendering '${component}'`, 'color: #e4af43;');
  } catch(e) {
    console.log(`%cMatched route '${to.name}' rendering an unknown component`, 'color: #e4af43;');
  }
  next();
});

// router.beforeEach(guardList([ensureUserLoaded, ensureUserAuthorized]));

export default router;
